<template>  
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link">
                        <router-link to="/loja" class="fa fa-home"></router-link>
                    </li>
                    <li class="item-link">
                        <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
                    </li>
                    <li class="item-link">
                        <span>Enviar Comprovante de Depósito</span>
                    </li>
                </ul>
            </div>                    
            <div class="main-content-area">
                <div class="form-item">                    
                    <div class="row">
                        <div class="col-xs-12">
                            <h2 class="box-title">Enviar Comprovante de Depósito</h2> 
                        </div>
                    </div>                     
                    <div class="docs-transferencia">
                        <form @submit.prevent="frmComprovanteDeposito" v-on:keyup.enter="EnviarComprovante()">
                            <div class="row">
                                <div class="col-md-0">
                                        <FormHelper :inputVar="frmComprovanteDeposito.codSolicitante"
                                                    :form="frmComprovanteDeposito"
                                                    label="Código do Solicitante"                                                                                                       
                                                    validationType="number"
                                                    type="hidden"></FormHelper>
                                </div>                                                                                         
                                <div class="col-md-3">
                                        <FormHelper :inputVar="frmComprovanteDeposito.emailSolicitante"
                                                    :form="frmComprovanteDeposito"
                                                    type="hidden"
                                                    label="E-mail do Solicitante"                                                   
                                                    validationType="email"></FormHelper>
                                </div>
                            </div>                            
                            <div class="row">
                                <div class="col-md-8">
                                    <form name="frm-cadastro-venda-direta" @submit.prevent="formTipoPessoa">
                                        <div class="col-md-3">
                                            <div class="choose-radio-methods">
                                                <label class="radio-option">
                                                    <input name="radio-tipo-pessoa"
                                                        value="1"
                                                        type="radio"
                                                        id="juridica"
                                                        checked
                                                        v-on:change="limparDadosDepositante($event)"
                                                        v-model="formRegister.tipoDepositante"/>
                                                    <span>Pessoa Jurídica</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="choose-radio-methods">       
                                                <label class="radio-option">
                                                    <input name="radio-tipo-pessoa"
                                                        value="0"
                                                        type="radio"
                                                        id="fisica"
                                                        checked
                                                        v-on:change="limparDadosDepositante($event)"
                                                        v-model="formRegister.tipoDepositante"/>
                                                    <span>Pessoa Física</span>
                                                </label>
                                            </div>
                                        </div>                                    
                                    </form>     
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="col-md-0">
                                        <FormHelper :inputVar="frmComprovanteDeposito.codDepositante"
                                                    :form="frmComprovanteDeposito"
                                                    label="Código do Depositante"                                               
                                                    type="hidden"
                                                    validationType="number"></FormHelper>
                                    </div>                                     
                                    <div class="col-md-3">
                                        <div v-show="formRegister.tipoDepositante == 1">
                                            <FormHelper :inputVar="frmComprovanteDeposito.CNPJDepositante"
                                                        :form="frmComprovanteDeposito"
                                                        id="CNPJDepositante"
                                                        label="CNPJ do Depositante"
                                                        mask="##.###.###/####-##"
                                                        validationType="cnpj"                                       
                                                        :disabled="frmComprovanteDeposito.loadingCpfCNPJDepositante || disabledForm"></FormHelper>
                                        </div> 
                                        <div v-show="formRegister.tipoDepositante == 0">
                                            <FormHelper :inputVar="frmComprovanteDeposito.CPFDepositante"
                                                        :form="frmComprovanteDeposito"
                                                        id="CPFDepositante"
                                                        label="CPF do Depositante"
                                                        :mask="['###.###.###-##']"
                                                        placeholder="000.000.000-00"
                                                        validationType="cpf"                                       
                                                        :disabled="frmComprovanteDeposito.loadingCpfCNPJDepositante || disabledForm"
                                                        ></FormHelper>
                                        </div>                                        
                                    </div>
                                    <div class="col-md-4">
                                        <FormHelper :inputVar="frmComprovanteDeposito.nomeDepositante"
                                                    :form="frmComprovanteDeposito"
                                                    label="Nome do Depositante"
                                                    validationType="quotes"
                                                    :disabled="true"></FormHelper>
                                    </div>  
                                    <div class="col-md-5">
                                        <div class="col-md-6">
                                            <FormHelper :inputVar="frmComprovanteDeposito.nrPedido"
                                                        :form="frmComprovanteDeposito"
                                                        label="Número do Pedido" 
                                                        mask="#######-#"
                                                        placeholder="0000000-0"
                                                        ></FormHelper> 
                                        </div>                                        
                                        <div class=" col-xs-2  col-only-button">
                                            <button aria-label="" id="btn-search" class="btn primary-button stretch" v-on:click="RecuperarClientePedido()">
                                                <i id="btn-icon" class="fa fa-search"></i>
                                            </button>
                                        </div>
                                        <h4>
                                            <span v-if="pedidoNEncontrado" style="color: red">Pedido não encontrado!</span>                                       
                                        </h4>
                                    </div> 
                                </div>                                                       
                            </div>                          
                            <div class="row">                                                              
                                <div class="col-md-6">
                                    <h2 class="box-title">Detalhes do Depósito</h2>
                                </div>                                
                            </div>
                            <div class="row">
                                <div class="col-md-12">                                                                 
                                    <div class="col-md-3">
                                        <FormHelper :inputVar="frmComprovanteDeposito.valorDeposito"
                                                    :form="frmComprovanteDeposito"
                                                    type="money"
                                                    label="Valor Depositado" 
                                                    :min="0.01"
                                                    :max="100000000"
                                                    validationType="rangeValue"></FormHelper>
                                    </div> 
                                    <div class="col-md-3">                                    
                                        <FormHelperBlob :inputVar="frmComprovanteDeposito.documentoComp"
                                                        :form="frmComprovanteDeposito"
                                                        label="Comprovante de Depósito"                                                   
                                                        type="file"                                                    
                                                        :fileTypes="['pdf','jpg']">                                                    
                                        </FormHelperBlob>              
                                    </div>                                                                      
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmComprovanteDeposito.descricao"
                                                    :form="frmComprovanteDeposito"
                                                    label="Motivo"
                                                    type="textarea"
                                                    placeholder="Motivo"></FormHelper>
                                    </div> 
                                </div>                                
                            </div>                                                    
                            <div class="row">
                                <div class="col-md-12"> 
                                    
                                </div>
                            </div> 
                        </form>
                    </div>
                </div>
                <div v-if="frmComprovanteDeposito.attemptSubmit && formErrors > 0" class="row">
                    <div class="col-md-12">
                        <div class="form-errors alert alert-danger" role="alert">
                            <i class="fa fa-warning"></i>
                            Seu formulário possui {{ formErrors }} erros. Por favor, corrija antes de prosseguir.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-1">
                        <button aria-label="Salvar" class="btn btn-primary" 
                        v-on:click="EnviarComprovante()" :disabled="(formErrors > 0 
                        && frmComprovanteDeposito.attemptSubmit) || loadingRegister">
                            Salvar
                        </button>                            
                    </div>                         
                    <div v-if="loadingRegister" class="col-md-5">
                        <Loader />
                    </div>                           
                </div>            
            </div>
        </div>
    </main>
</template>
<script>
    import FormHelper from "../../components/partials/FormHelper.vue"; 
    import FormHelperBlob from "../../components/partials/FormHelperBlob.vue";      
    import axios from 'axios';
    
    export default {
        name: "Deposito",
        data() {
            return {
                HasNoData: true,  
                invalidCnpj: true,
                loadingRegister: false,
                disabledForm: false,
                pedidoNEncontrado: false,
                notaNEncontrada: false,
                digitado: true,
                file: null,

                formRegister: {
                    tipoDepositante: 1                    
                },

                frmComprovanteDeposito: {
                    attemptSubmit: false,

                    //* Dados Solicitante */
                    codSolicitante: new this.formInput(false),                    
                    emailSolicitante: new this.formInput(false),

                    //* Dados Depositante */                    
                    codDepositante: new this.formInput(false),
                    nomeDepositante: new this.formInput(false),
                    CPFDepositante: new this.formInput(),
                    CNPJDepositante: new this.formInput(),                     
                    nrPedido: new this.formInput(false),                    
                    loadingCpfCNPJDepositante: false,

                    //**Dados Saldo e documentação */
                    valorDeposito: new this.formInput(),
                    documentoComp: new this.formInput(true),                  
                    descricao: new this.formInput(),                    

                    /* Pesssoa Juridica */
                    cnpj: new this.formInput(false),                    
                    cnpjInvalid: false, 
                    loadingCnpj: false                    
                }
            }
        },
        components: {
            FormHelper,
            FormHelperBlob
        },
        mounted(){
            localStorage.currentStep = 0;
            const self = this;
            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning",
                    }).then(
                        () =>
                        (location.href =
                            `${self.$SiteUrl}/login?redirectTo=` + location.href)
                    );
                },
            });
            self.ValidarParametros('HABILITAR_ENVIO_DEPOSITO_SITE');    
        },
        computed: {            
            formErrors: function () {                
                //Retorna os campos que estão com erro de validação
                let errors = Object.keys(this.frmComprovanteDeposito).filter((key) => this.frmComprovanteDeposito[key].validation && !this.frmComprovanteDeposito[key].validation.status)
                
                //Retira 1 validação porque exite apenas CPF ou CNPJ para o cliente.
                return (errors.length - 1);             
            }
        },
        watch:{
            "frmComprovanteDeposito.CNPJDepositante.value": async function (val) {
                if (val.length == 18) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let cliente = await this.ConsultarCliente(cnpj);                    
                    if (cliente != null){                                           
                        this.frmComprovanteDeposito.nomeDepositante.value = cliente.CliRazaosocial; 
                        this.frmComprovanteDeposito.codDepositante.value = cliente.CliCodigo;                      
                    }
                    else
                    {
                        this.frmComprovanteDeposito.nomeDepositante.value = '';
                        this.frmComprovanteDeposito.codDepositante.value = '';
                        swal({
                            title: 'Cliente não encontrado!',                           
                            icon: 'warning'
                        });
                    }  
                }
            }, 
            "frmComprovanteDeposito.CPFDepositante.value": async function (val) {
                if (val.length == 14) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let cliente = await this.ConsultarCliente(cnpj);                    
                    if (cliente != null){                                            
                        this.frmComprovanteDeposito.nomeDepositante.value = cliente.CliRazaosocial;  
                        this.frmComprovanteDeposito.codDepositante.value = cliente.CliCodigo;                     
                    }
                    else
                    {
                        this.frmComprovanteDeposito.nomeDepositante.value = '';
                        this.frmComprovanteDeposito.codDepositante.value = '';   
                        swal({
                            title: 'Cliente não encontrado!',                           
                            icon: 'warning'
                        });
                    } 
                }
            },
            "frmComprovanteDeposito.nrPedido.value": async function (val) {
                this.pedidoNEncontrado = false;
            }           
        },   
        methods: {            

            formInput: function (required, value) {
                // Define um padrão para estrutura de cada input do formulário
                this.required = required !== undefined ? required : true;
                this.value = value !== undefined ? value : "";

                this.validation = {
                    status: !this.required,
                    message: this.required ? "Por favor, preencha o campo acima" : ""
                };
            },

            EnviarComprovante: async function(){ 
                this.frmComprovanteDeposito.attemptSubmit = true;

                if (this.formErrors > 0)
                    return null;

                if (this.frmComprovanteDeposito.nrPedido.value != null && this.frmComprovanteDeposito.nrPedido.value.split("-")[0] > 0){
                    const pedidodv = this.frmComprovanteDeposito.nrPedido.value.split("-");                

                    if(pedidodv[1] == null){
                        return swal({
                                    title: 'Erro ao Salvar o Comprovante!',
                                    text: 'Pedido no formato incorreto! \n Por gentileza, preencher no formato "0000000-0" ',
                                    icon: 'warning'
                        });
                    }else{

                        let pedidoCliente = await this.ConsultarClientePedido(pedidodv[0], pedidodv[1]);
                        
                        if (pedidoCliente.cliCodigo != this.frmComprovanteDeposito.codDepositante.value)
                        {
                            return swal({
                                    title: 'Erro ao Salvar o Comprovante!',
                                    text: 'O pedido informado não está cadastrado para o depositante informado!',
                                    icon: 'warning'
                            });
                        }                        
                    }
                }

                var dados = new FormData(); 
                dados.append('DepDocumento', this.frmComprovanteDeposito.documentoComp.value);
                dados.append('CliCodigo', JSON.parse(localStorage.getItem('usuarioLogado')).DadosCliente.CliCodigo); 
                dados.append('CliCodigoDeposito', this.frmComprovanteDeposito.codDepositante.value);
                dados.append('DepValor', this.frmComprovanteDeposito.valorDeposito.value.toString().replace('.', ','));
                dados.append('DepDescricao', this.frmComprovanteDeposito.descricao.value);
                dados.append('PevCodigo', this.frmComprovanteDeposito.nrPedido.value.split("-")[0]);
            
                return axios({
                    method: "POST",
                    url: this.$apiUrlAPI + "ComprovanteDeposito/GerarComprovanteDeposito",
                    headers: {"Content-Type": "multipart/form-data"},                    
                    data: dados                    
                }).then((response) => {                                          
                    if(response.status == 200){
                        if(response.data.registroGerado > 0 ) { 
                            swal({
                                title: "Solicitação Enviada",
                                text: "Foi gerado o comprovante número: " + response.data.registroGerado,
                                icon: "success"
                            }).then(() => location.href = `${this.$SiteUrl}/loja/minha-conta`)                                                                                                                        
                        }else{
                            swal({
                                title: 'Erro ao Enviar Comprovante!',
                                text: response.data.descricaoErro,
                                icon: 'warning'
                            })
                        }                        
                    }                   
                }).catch((error) =>{
                    swal({
                                title: 'Erro ao Enviar Comprovante!',
                                text: 'Não foi possível enviar as informações. Erro: ' + error,
                                icon: 'warning'
                    })
                });
            },            

            limparDadosDepositante: function(event){
                this.frmComprovanteDeposito.CPFDepositante.value = '';
                this.frmComprovanteDeposito.CNPJDepositante.value = '';
                this.frmComprovanteDeposito.nomeDepositante.value = '';
                this.frmComprovanteDeposito.codDepositante.value = ''; 
                //this.frmComprovanteDeposito.loadingCnpj = true;             
            },

            async ConsultarCliente (cnpj) { 
                var cliente = null;
                await axios({
                    method: "POST",
                    url: this.$apiUrl + "Cliente.svc/getload/cli",
                    headers: {"Content-Type": "application/json"},                    
                    data: {cli_ciccgc: cnpj}                    
                })
                .then((response) => {                                          
                    if(response.status == 200){
                        if(response.data.CliCodigo > 0) {  
                            console.log(response.data);
                            cliente = response.data;                                                                  
                        }                        
                    }                   
                }).catch((error) =>{
                    swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar as informações. Erro: ' + error,
                                icon: 'warning'
                    })
                });  
                return cliente              
            }, 

            async RecuperarClientePedido () {                 
                const pedidodv = this.frmComprovanteDeposito.nrPedido.value.split("-");                

                if(pedidodv[1] == null){
                    return swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Pedido no formato incorreto! \n Por gentileza, seguir o formato "0000000-0" ',
                                icon: 'warning'
                    });
                }else{

                let pedidoCliente = await this.ConsultarClientePedido(pedidodv[0], pedidodv[1]);

                console.log(pedidoCliente);
                if(pedidoCliente != null){
                        this.frmComprovanteDeposito.nomeDepositante.value = pedidoCliente.cliRazaosocial;
                        this.frmComprovanteDeposito.codDepositante.value = pedidoCliente.cliCodigo;

                        if(pedidoCliente.cliCiccgc.length <= 11) {
                            this.formRegister.tipoDepositante = 0;
                            this.frmComprovanteDeposito.CPFDepositante.value = pedidoCliente.cliCiccgc;                            
                        }
                        else{
                            this.formRegister.tipoDepositante = 1;
                            this.frmComprovanteDeposito.CNPJDepositante.value = pedidoCliente.cliCiccgc;
                    }
                }
                else{
                    this.frmComprovanteDeposito.nomeDepositante.value = '';
                    this.pedidoNEncontrado = true;
                    swal({
                            title: 'Pedido não encontrado!',                           
                            icon: 'warning'
                    }); 
                }
                }
            },

            async ConsultarClientePedido(pedido, dv) {
                var clientePedido = null;
                await axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Cliente/ConsultarClientePedido",
                    headers: {"Content-Type": "application/json"}, 
                    params: {
                        codigoPedido: pedido,
                        dvCodigoPedido: dv
                    }                    
                })
                .then((response) => {                                          
                    if(response.status == 200){
                        console.log(response.data);
                        clientePedido = response.data;
                    }else{
                        return swal({
                            title: 'Pedido não encontrado!',                           
                            icon: 'warning'
                        });
                    }
                }).catch((error) =>{ 
                    return swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar o pedido. Erro: ' + error,
                                icon: 'warning'
                    });
                });
                
                return clientePedido;
            },
            
            async ValidarParametros(parNome){                 
                await axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Parametros/Consultar",
                    headers: {"Content-Type": "application/json"},                    
                    params: {'nomeParametro': parNome}
                }).then(response => {  
                    if(response.status == 200){ 
                        if(response.data.parValor == "N")
                        {                                           
                            swal({
                                title: "Erro ao Carregar Página",
                                text: "Esta página não está habilitada para uso. Por favor, consulte o administrador do sistema!",
                                icon: "warning"
                            }).then(() => location.href = `${this.$SiteUrl}/loja/minha-conta`)                         
                        }
                    }                          
                }).catch(function (error) {
                    console.log(error);                
                });
            }, 
        }
    };
</script>